// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logging-main {
    width: 100%;
    height: 100vh;
}

.logging-main__header {
    font-size: 4rem;
    font-weight: 600;
    text-align: center;
}

.logging-main__toolbar {
    display: flex;
    align-items: flex-end;
    gap: 1rem;
    margin: 2rem 4rem 0;
}

.logging-main__service {
    width: 30rem;
    margin-right: 1rem;
    text-align: left;
}

.logging-main__service select {
    height: 4rem;
    font-size: 1.6rem;
}

.logging-main__cancel {
    background-color: #d22e37;
}

.logging-main__reset {
    flex-shrink: 0;
    margin-left: auto;
    white-space: nowrap;
    background-color: #757575;
}

.logging-main__hint {
    margin: 1rem 4rem 0;
    font-size: 1.3rem;
    color: #9e9e9e;
    text-align: left;
}

.logging-main__override {
    margin: 1rem 4rem 0;
    padding: .8rem 1rem;
    border-left: 4px solid #ffa000;
    background-color: #fff8e1;
    color: #795548;
    font-size: 1.3rem;
    text-align: left;
}

.logging-main__message {
    margin: 1rem 4rem 0;
    color: #26a69a;
    text-align: left;
}

.logging-main__errors {
    margin: 1rem 4rem 0;
    padding: 1rem;
    border-left: 4px solid #d22e37;
    background-color: #fdecea;
    color: #b71c1c;
    font-family: Consolas, "Courier New", monospace;
    font-size: 1.3rem;
    text-align: left;
    white-space: pre-wrap;
}

.logging-main__editor {
    flex: 1;
    min-height: 0;
    margin: 1rem 4rem 0;
    width: auto;
    padding: 1rem;
    border: 1px solid #e0e0e0;
    resize: none;
    font-family: Consolas, "Courier New", monospace;
    font-size: 1.3rem;
    line-height: 1.4;
    white-space: pre;
    overflow: auto;
}

.logging-main__example {
    margin: 1rem 4rem 1.5rem;
    text-align: left;
    font-size: 1.3rem;
}

.logging-main__example summary {
    cursor: pointer;
    color: #616161;
}

.logging-main__example pre {
    margin-top: .5rem;
    padding: 1rem;
    background-color: #f5f5f5;
    font-size: 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/logging/LoggingMain.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,cAAc;IACd,+CAA+C;IAC/C,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,+CAA+C;IAC/C,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,iBAAiB;AACrB","sourcesContent":[".logging-main {\r\n    width: 100%;\r\n    height: 100vh;\r\n}\r\n\r\n.logging-main__header {\r\n    font-size: 4rem;\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n.logging-main__toolbar {\r\n    display: flex;\r\n    align-items: flex-end;\r\n    gap: 1rem;\r\n    margin: 2rem 4rem 0;\r\n}\r\n\r\n.logging-main__service {\r\n    width: 30rem;\r\n    margin-right: 1rem;\r\n    text-align: left;\r\n}\r\n\r\n.logging-main__service select {\r\n    height: 4rem;\r\n    font-size: 1.6rem;\r\n}\r\n\r\n.logging-main__cancel {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.logging-main__reset {\r\n    flex-shrink: 0;\r\n    margin-left: auto;\r\n    white-space: nowrap;\r\n    background-color: #757575;\r\n}\r\n\r\n.logging-main__hint {\r\n    margin: 1rem 4rem 0;\r\n    font-size: 1.3rem;\r\n    color: #9e9e9e;\r\n    text-align: left;\r\n}\r\n\r\n.logging-main__override {\r\n    margin: 1rem 4rem 0;\r\n    padding: .8rem 1rem;\r\n    border-left: 4px solid #ffa000;\r\n    background-color: #fff8e1;\r\n    color: #795548;\r\n    font-size: 1.3rem;\r\n    text-align: left;\r\n}\r\n\r\n.logging-main__message {\r\n    margin: 1rem 4rem 0;\r\n    color: #26a69a;\r\n    text-align: left;\r\n}\r\n\r\n.logging-main__errors {\r\n    margin: 1rem 4rem 0;\r\n    padding: 1rem;\r\n    border-left: 4px solid #d22e37;\r\n    background-color: #fdecea;\r\n    color: #b71c1c;\r\n    font-family: Consolas, \"Courier New\", monospace;\r\n    font-size: 1.3rem;\r\n    text-align: left;\r\n    white-space: pre-wrap;\r\n}\r\n\r\n.logging-main__editor {\r\n    flex: 1;\r\n    min-height: 0;\r\n    margin: 1rem 4rem 0;\r\n    width: auto;\r\n    padding: 1rem;\r\n    border: 1px solid #e0e0e0;\r\n    resize: none;\r\n    font-family: Consolas, \"Courier New\", monospace;\r\n    font-size: 1.3rem;\r\n    line-height: 1.4;\r\n    white-space: pre;\r\n    overflow: auto;\r\n}\r\n\r\n.logging-main__example {\r\n    margin: 1rem 4rem 1.5rem;\r\n    text-align: left;\r\n    font-size: 1.3rem;\r\n}\r\n\r\n.logging-main__example summary {\r\n    cursor: pointer;\r\n    color: #616161;\r\n}\r\n\r\n.logging-main__example pre {\r\n    margin-top: .5rem;\r\n    padding: 1rem;\r\n    background-color: #f5f5f5;\r\n    font-size: 1.2rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
